







import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        tenants: {
            type: Array,
        },
        ticketsData: {
            type: Array as PropType<object>,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        const headers = [
            { text: 'Name', value: 'name', width: 200 },
            { text: 'Email', value: 'email' },
            { text: 'Rides Taken', value: 'used', align: 'center' },
            {
                text: 'Rides Cancelled',
                value: 'cancelled',
                align: 'center',
            },
            {
                text: 'Rides Missed',
                value: 'valid',
                align: 'center',
            },
        ];

        if (this.tenants.length > 0) {
            // insert tenant column right after the Email column
            const fieldIndex = headers.findIndex((h: any) => h.text === 'Email');
            headers.splice(fieldIndex + 1, 0, {
                text: 'Tenant',
                value: 'tenantId',
                width: 300,
            });
        }

        return { headers };
    },
    methods: {
        getTenantName(item: any): string {
            const tenant: any = this.tenants.find((t: any) => t.tenantId === item?.tenantId);
            return tenant ? tenant.firmName : null;
        },
    },
});
